import { Component } from '@angular/core';
import { AppState } from '../../../../app/app.global';
import { Utils } from '../../../../providers/service/utils';
import { HttpService } from '../../../../providers/service/httpservice';
import { SALARYINFO } from '../../../../providers/config/serviceurl';
import { StorageService } from '../../../../providers/service/storageservice';

@Component({
  selector: 'salaryinquiry',
  templateUrl: 'salaryinquiry.html'
})

export class SalaryInquiry {
	sDate;
	user:any;
	salaryInfo:any={};
	year:any;
	month:any;
	dateSelectFlag:boolean=true;
	nDate:Date;
	constructor(public global: AppState,private httpService:HttpService) {
		  let currentDate = new Date();
		  this.nDate = currentDate;
		  this.year = currentDate.getFullYear();
      this.month = +currentDate.getMonth() + 1;  
      this.sDate = Utils.dateFormat(currentDate,'yyyy-MM');
      this.user = StorageService.getObj('currentUser');
      this.salaryInfo = StorageService.getObj('salaryInfo');
      this.httpService.get(SALARYINFO,{"hd":this.user.hd,"year":this.year,"month":this.month}).then(anyObj => this.handleIniSalaryData(anyObj));
	}
	handleIniSalaryData(obj:any){
  	if(obj){
     this.salaryInfo = obj;
     StorageService.setObj("salaryInfo",this.salaryInfo);
    }
    //else{
		//	this.getPreMonth(this.nDate);
		//	this.year = this.nDate.getFullYear();
		//	this.month = this.nDate.getMonth()+1;
		//	this.sDate = Utils.dateFormat(this.nDate,'yyyy-MM');
		//	this.httpService.get(SALARYINFO,{"hd":this.user.hd,"year":this.year,"month":this.month}).then(anyObj => this.handleIniSalaryData(anyObj));
		//}
  }

  changeDate($event){
  	let cdate = new Date($event);
  	this.year = cdate.getFullYear();
    this.month = cdate.getMonth()+1; 
    if(this.dateSelectFlag){
      this.httpService.get(SALARYINFO,{"hd":this.user.hd,"year":this.year,"month":this.month}).then(anyObj => this.handleSalaryData(anyObj));
    }else{
    	this.httpService.get(SALARYINFO,{"hd":this.user.hd,"year":this.year}).then(anyObj => this.handleSalaryData(anyObj));
    }
  }
  handleSalaryData(obj:any){
  	if(obj){
     this.salaryInfo = obj;
     StorageService.setObj("salaryInfo",this.salaryInfo);
		}else{
		  this.salaryInfo = {};
		}
  }
  
  loadMore(refresher){
    setTimeout(() => {
      refresher.complete();
    }, 500);
  }
  //下拉刷新
  doRefresh(refresher){
    setTimeout(() => {
      refresher.complete();
    }, 1000);
  }
  swapDate(){
  	this.dateSelectFlag = !this.dateSelectFlag;
   if(this.dateSelectFlag){
   	 this.httpService.get(SALARYINFO,{"hd":this.user.hd,"year":this.year,"month":this.month}).then(anyObj => this.handleSalaryData(anyObj));
   }else{
   	 this.httpService.get(SALARYINFO,{"hd":this.user.hd,"year":this.year}).then(anyObj => this.handleSalaryData(anyObj));
   }
  }
  
  getPreMonth(date){
     let year = date.getFullYear();
     let month = date.getMonth();
     let cyear = year;
     let cmonth = parseInt(month)-1;
     if(cmonth == 0){
     	  cyear = parseInt(cyear)-1;
     	  cmonth = 12;
     }
     let cdate = new Date(cyear,month,0);
     this.nDate = cdate;
  }
  
  
  
}


// WEBPACK FOOTER //
// ./src/pages/application/finance/salary/salaryinquiry.ts